export default __webpack_public_path__ + "static/media/marker_cluster.df320f24.svg";